module.exports = __webpack_public_path__ + "img/loading.d550a72c.gif";